"use client";

import { useAuth } from '@/context/AuthContext';
import { useRouter } from 'next/navigation';
import { useEffect, ReactNode } from 'react';

const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    // If authentication is done and there's still no user, redirect.
    if (!loading && !user) {
      router.push('/login');
    }
  }, [user, loading, router]);

  // While loading, AuthProvider shows a loading screen.
  // If there is a user, show the children.
  // If no user, the effect will handle the redirect.
  if (user) {
    return <>{children}</>;
  }

  // Return null to prevent rendering anything while the redirect is happening.
  return null;
};

export default PrivateRoute;
